import { LOGO_URL } from "@/lib/constants";

export function NetstaffLogo({ className = "h-10 w-10", showText = true, textClass = "text-2xl" }) {
  return (
    <div className="flex items-center gap-3" data-testid="netstaff-logo">
      <img src={LOGO_URL} alt="NetStaff" className={`${className} rounded-lg object-cover`} />
      {showText && (
        <div className="leading-none">
          <div className={`font-bold ${textClass}`} style={{ fontFamily: "Outfit, sans-serif" }}>
            <span className="text-brand-navy">Net</span>
            <span className="text-brand-teal">Staff</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-semibold mt-0.5">
            Healthcare Solutions
          </div>
        </div>
      )}
    </div>
  );
}
